import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SelectedFieldsState {
  fieldUuids: string[];
}

const initialSelectedFieldsState: SelectedFieldsState = {
  fieldUuids: [],
};

const selectedFieldsSlice = createSlice({
  name: 'selectedFields',
  initialState: initialSelectedFieldsState,
  reducers: {
    setSelectedFieldUuids: (state, action: PayloadAction<string[]>) => {
      state.fieldUuids = action.payload;
    },
    pushSelectedFieldUuids: (state, action: PayloadAction<string[]>) => {
      const uniqUuids = Array.from(
        new Set([...state.fieldUuids, ...action.payload]),
      );

      state.fieldUuids = uniqUuids;
    },
    removeSelectedFieldUuids: (state, action: PayloadAction<string[]>) => {
      const uuidSet = new Set(state.fieldUuids);

      action.payload.forEach((uuid) => uuidSet.delete(uuid));

      state.fieldUuids = Array.from(uuidSet);
    },
    resetSelectedFields: (state) => {
      state.fieldUuids = [];
    },
  },
});

export { selectedFieldsSlice };
